/**
 * RTK Query API for Live Class Overview feature.
 *
 * Base API definition only — endpoints are injected by domain files:
 *   - semesterEndpoints.ts
 *   - overviewEndpoints.ts
 *   - klassenlisteEndpoints.ts
 *   - tableViewEndpoints.ts
 *
 * Import hooks from the domain files directly, or from ./index.ts.
 *
 * @module live-overview/api
 */

import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';

export const liveOverviewApi = createApi({
    reducerPath: 'liveOverviewApi',
    baseQuery: fakeBaseQuery(),
    tagTypes: [
        'Semesters',
        'DraftItems',
        'Confirmations',
        'Unenrollments',
        'LessonDetails',
        'StudentDetails',
        'FlexOverview',
        'InitData',
        'ListeOverview',
        'ClassInfo',
        'TablePrefs',
        'CustomColumns',
        'TableViews',
    ],
    endpoints: () => ({}),
});
